import React from 'react';
import PointGenerateSearchBox from '../PointGenerateSearchBox';
import PointGenerateUserList from '../PointGenerateUserList';
import PointGenerateNavbar from '../../../point/generate/PointGenerateNavbar';
import PointGenerateSelectedUserList from '../PointGenerateSelectedUserList';
import './PointGenerateWrap.scss';

const PointGenerateWrap = (props) => {
  const {
    pointCauseSelectList,
    setData,
    getList,
    issuedUser,
    onCheckUser,
    onSubmit,
    toggleModal,
    form,
    initCause,
    applyBulkPointInfo,
    getExcelDownload,
  } = props;
  const { userList, selectedUserInfoList, selectedUserIdList, pointBulkApply } = issuedUser;

  return (
    <div className="point-generate-wrap">
      {/*하단 네브바*/}
      <PointGenerateNavbar onSubmit={onSubmit} toggleModal={toggleModal} />

      {/*포인트 발급 받을 유저 정보 리스트 + 발급받을 포인트 정보*/}
      <PointGenerateSelectedUserList
        pointCauseSelectList={pointCauseSelectList}
        setData={(data) =>
          setData({
            path: ['issuedUser', ...data.path],
            value: data.value,
          })
        }
        applyBulkPointInfo={applyBulkPointInfo}
        selectedUserInfoList={selectedUserInfoList}
        selectedUserIdList={selectedUserIdList}
        onCheckUser={onCheckUser}
        form={form}
        initCause={initCause}
        pointBulkApply={pointBulkApply}
      />

      {/*유저 검색 박스*/}
      <PointGenerateSearchBox
        setData={(data) =>
          setData({
            path: ['issuedUser', 'userList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={userList.searchData}
        getList={getList}
      />

      {/*포인트 발급 받을 유저 리스트*/}
      <PointGenerateUserList
        list={userList.list}
        pagination={userList.pagination}
        sortOption={userList.sortOption}
        selectedUserIdList={selectedUserIdList}
        getList={getList}
        onCheckUser={onCheckUser}
        getExcelDownload={getExcelDownload}
      />
    </div>
  );
};

export default PointGenerateWrap;
